var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloseMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.404.782l11.314 11.314-2.122 2.122L.282 2.904z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.282 12.096L11.596.782l2.122 2.122L2.404 14.218z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseMenu);
export default __webpack_public_path__ + "static/media/icon-close-menu.32169d313e5fa6171811fd73fe1e3568.svg";
export { ForwardRef as ReactComponent };